import React, { FC, useMemo } from "react";
import { StatusRendererProps } from "../../../components/Overlay";
import StatusMessage from "./StatusMessage";
import { getVolleyballCodeMeta } from "../constants";
import { SIDE } from "_constants";

export const VolleyballStatusRenderer: FC<StatusRendererProps> = ({
  message,
  side,
  homeTeam,
  awayTeam,
  normalizedCode,
  activeTeam,
  status,
  width,
  height,
  Icon,
}) => {
  const meta = useMemo(
    () => getVolleyballCodeMeta(status, normalizedCode),
    [status, normalizedCode]
  );

  const resolvedSide: SIDE =
    meta.side ??
    (side === SIDE.AWAY
      ? SIDE.AWAY
      : side === SIDE.HOME
      ? SIDE.HOME
      : SIDE.NO_SIDE);

  const resolvedCode =
    meta.normalizedCode ?? normalizedCode ?? meta.baseCode ?? "";

  const resolvedTeam =
    resolvedSide === SIDE.HOME
      ? homeTeam || activeTeam
      : resolvedSide === SIDE.AWAY
      ? awayTeam || activeTeam
      : activeTeam;

  const baseCode = resolvedCode.slice(-3);

  const shouldRenderStatusMessage =
    resolvedCode &&
    !["250", "259", "258", "260", "257"].some((code) => baseCode === code);

  if (!shouldRenderStatusMessage) return null;

  return (
    <>
      <StatusMessage
        title={message}
        normalizedCode={resolvedCode}
        team={resolvedTeam}
        side={resolvedSide}
        status={status}
        width={width}
        height={height}
        Icon={Icon}
      />
    </>
  );
};
